<template>
  <ValidationObserver ref="actionVal" v-slot="{ invalid }">
    <v-form autocomplete="off" class="fill-height">
      <v-card class="fill-height d-flex flex-column">
        <v-toolbar dark color="primary" flat style="max-height: 64px;">
          <v-toolbar-title>
            Action EDN '{{ value.ednNumber }}' for Unit
            <router-link class="accent--text text--lighten-1" :to="{ name: 'unit', params: { unitId: value.unitId } }">{{ value.unitNumber }}</router-link>
          </v-toolbar-title>
          <slot name="header"></slot>
        </v-toolbar>

        <v-card-text class="flex-grow-1">
          <stale-data-alert :is-stale="value.isStale || false" message="This defect notice has been updated by another user. Please refresh to see updated data." :loading="refreshing" @refresh="refreshPage"></stale-data-alert>

          <v-container v-if="!value.isStale">
            <v-row xs12>
              <v-col>
                <ValidationProvider vid="received">
                  <v-text-field v-model="value.receivedTotal" label="Initially Received" type="number" disabled hide-details></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col>
                <ValidationProvider vid="additionallyreceived" name="Additionally Received" rules="required|min_value:0|additionallyreceived_max" v-slot="{ errors }">
                  <v-text-field v-model.number="additionallyReceived" label="Additionally Received" type="number" min="0" :max="6 - value.receivedTotal" :error-messages="errors"></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col>
                <ValidationProvider name="Completed on Receipt" rules="required|min_value:0|max_value:6|checkTotalDefects" v-slot="{ errors }">
                  <v-text-field
                    v-model.number="value.completedOnReceipt"
                    label="Completed on Receipt"
                    placeholder="e.g. 1"
                    :error-messages="errors"
                    type="number"
                    min="0"
                    :max="value.receivedTotal + additionallyReceived"
                    required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!value.isStale">
          <v-spacer></v-spacer>
          <slot name="actions"></slot>
          <v-btn color="red white--text" @click="deleteEdn" v-if="userIsFleetManager">Delete EDN</v-btn>
          <v-btn color="primary" :disabled="invalid" @click="submitForm">Action EDN</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </ValidationObserver>
</template>
<script>
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { DateFormat } from '@/plugins/date-filter';
import StaleDataAlert from '@/components/DefectNotices/StaleDataAlert.vue';

export default {
  props: {
    value: {
      required: true
    }
  },
  components: { StaleDataAlert, ValidationObserver, ValidationProvider },
  computed: {
    formattedReceivedDate() {
      return moment(this.value.receivedDate).format(DateFormat.DefaultDisplay);
    }
  },
  methods: {
    async init() {
      this.$refs.actionVal.reset();
      this.id = this.value.id;
      this.submitted = false;
      this.additionallyReceived = 0;

      this.completedDefects = [];
    },
    async submitForm() {
      const isValid = await this.$refs.actionVal.validate();
      if (!isValid) {
        return;
      }

      this.submitted = true;
      let data = {
        id: this.id,
        model: { ...this.value },
        newReceivedTotal: this.value.receivedTotal + this.additionallyReceived
      };
      this.$emit('action', data);
      this.$nextTick(() => {
        this.submitted = false;
      });
    },
    deleteEdn() {
      this.$confirmCancel.show(`Delete Defect Notice?`, `<p>This will permanently delete this Defect Notice record</p>`, 'Delete it');
      const confirmHandler = confirmed => {
        this.$confirmCancel.$off('confirm-cancel', confirmHandler);
        if (!confirmed) {
          return;
        }

        this.$emit('delete-edn', { id: this.value.id, source: 'action' });
      };
      this.$confirmCancel.$on('confirm-cancel', confirmHandler);
    },
    async refreshPage() {
      this.refreshing = true;
      try {
        // Emit an event to the parent to refresh the defect page
        this.$emit('refresh-page');

        // Close the modal
        this.$emit('close-modal');
      } catch (error) {
        this.$toast.error('Failed to refresh page');
      } finally {
        this.refreshing = false;
      }
    }
  },
  data() {
    return {
      id: '',
      submitted: false,
      additionallyReceived: 0,
      completedDefects: [],
      numberData: [1, 2, 3, 4, 5, 6],
      showDelete: false,
      refreshing: false
    };
  },
  async created() {
    this.$validator.extend('checkTotalDefects', {
      validate: value => {
        return value <= this.value.receivedTotal + this.additionallyReceived;
      },
      getMessage: fieldName => `${fieldName} cannot be larger than total received`
    });
    this.$validator.extend('additionallyreceived_max', {
      validate: value => {
        return value <= 6 - this.value.receivedTotal;
      },
      getMessage: fieldName => `${fieldName} + Initially Recieved cannot be larger than 6`
    });
  }
};
</script>

<style lang="scss" scoped>
.completed-defects {
  th,
  td {
    padding-left: 8px;
    padding-right: 8px;
  }
  tbody {
    tr {
      td:first-child,
      td:last-child {
        width: 1px;
        white-space: nowrap;
      }
      td:nth-child(3) {
        width: 30%;
      }
      td:nth-child(4) {
        width: 10%;
      }
    }
  }
}
</style>
